export default __webpack_public_path__ + "static/media/Logo-contact.5f773eb4.svg";